import { profileBG } from "utils/assets_exports/images";
// import RestoreFromTrashOutlinedIcon from "@mui/icons-material/RestoreFromTrashOutlined"; // restore
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever"; // delete
import { CustomComponentProps } from "utils/types/general.types";
import { DemoComunityListObject } from "assets/data/communities";
import { Link } from "react-router-dom";

export type CommunityHeaderProps = CustomComponentProps & {
    group: DemoComunityListObject;
    // handleBlock: Function;
    // handleDelete: Function;
    // handleRestore: Function;
};

const CommunityHeader = ({
    group,
    // handleBlock,
    // handleDelete,
    // handleRestore,
    className,
    style
}: CommunityHeaderProps) => {
    return (
        <div className={`profile-header w-full ${className}`} style={style}>
            <div className="cover-bg relative">
                <img
                    className="cover-image"
                    src={profileBG}
                    alt="community cover picture"
                />
                <div className="avatar">
                    <img
                        id="user-avatar"
                        className="avatar-image"
                        src={group.img}
                        alt=""
                    />
                    {/* <div className="avatar-button">
                        <DeleteForeverIcon
                            className="text-white"
                            fontSize="small"
                        />
                    </div> */}
                </div>
                <div className="cover-overlay"></div>
                {/* <div
                    className="cover-edit modal-trigger"
                    data-modal="change-cover-modal"
                >
                    <DeleteForeverIcon
                        className="text-white"
                        fontSize="small"
                    />
                    <span className="text-sm text-white pl-1">
                        Block cover image
                    </span>
                </div> */}
            </div>

            <div className="flex flex-col lg:flex-row justify-center lg:justify-between items-center lg:items-end gap-5">
                <div className="flex flex-col justify-center items-center lg:items-start">
                    <div className="profile-subheader px-3">
                        {/* group  */}
                        <div className="subheader-middle">
                            <h2>
                                {group.title}
                                {/* {group.status !== "active" && (
                                    <span className="text-red-500 dark:text-red-400">
                                        ( {group.status} )
                                    </span>
                                )}{" "} */}
                            </h2>
                        </div>
                    </div>
                    {group.about && (
                        <div className="profile-about pt-5 pb-5 lg:pb-0 px-3">
                            <p className=" text-center w-full dark:text-white">
                                {group.about}
                            </p>
                        </div>
                    )}
                </div>

                <div className="community-page-members-section flex justify-center lg:justify-start items-center gap-3">
                    <div className="members-group flex justify-start items-center cursor-pointer">
                        <img
                            src="https://via.placeholder.com/300x300"
                            data-demo-src="assets/img/avatars/dan.jpg"
                            data-user-popover="1"
                            alt=""
                        />
                        <img
                            src="https://via.placeholder.com/300x300"
                            data-demo-src="assets/img/avatars/david.jpg"
                            data-user-popover="4"
                            alt=""
                        />
                        <img
                            src="https://via.placeholder.com/300x300"
                            data-demo-src="assets/img/avatars/edward.jpeg"
                            data-user-popover="5"
                            alt=""
                        />
                        <img
                            src="https://via.placeholder.com/300x300"
                            data-demo-src="assets/img/avatars/milly.jpg"
                            data-user-popover="7"
                            alt=""
                        />
                    </div>
                    <div className="members-text">
                        <Link
                            to={`/communities/view/${group.id}/members`}
                            className="fonr-semibold dark:text-white cursor-pointer"
                        >
                            6.5k members
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommunityHeader;
